<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 25 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 15.042V0H2.737L7.429 8.464L8.97 11.661H9.062C9.00067 10.879 8.924 10.0433 8.832 9.154C8.75533 8.24933 8.717 7.37533 8.717 6.532V0H11.27V15.042H8.533L3.841 6.578L2.3 3.381H2.208C2.26933 4.17833 2.33833 5.014 2.415 5.888C2.507 6.762 2.553 7.62067 2.553 8.464V15.042H0ZM15.0938 15.042V0H24.1788V2.254H17.7618V6.509H23.2358V8.763H17.7618V15.042H15.0938Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconInvoice',
  props: {
    width: {
      type: Number,
      default: 26,
    },
    height: {
      type: Number,
      default: 13.5,
    },
  },
};
</script>

<style scoped>
</style>